<template>
  <div class="box">
    <ul class="list" v-if="tabIndex === 0">
      <li v-for="item in checkListData" :key="item.id" @click="pushTo(item)">
        <div class="left">
          <img :src="item.image" alt="">
        </div>
        <div class="right">
          <div class="title">
            <span>{{item.title}}</span>
          </div>
          <div class="message">
            <div class="tag" v-if="item.tag && JSON.parse(item.tag)[0]">
              <span v-if="item.tag && JSON.parse(item.tag)[0]">{{JSON.parse(item.tag)[0]}}</span>
            </div>
            <span class="time">{{item.createtime | formatDate}}</span>
          </div>
        </div>
      </li>
    </ul>
    <ul class="list" v-if="tabIndex === 1">
      <li v-for="item in liveListData" :key="item.id" @click="pushTo(item)">
        <div class="left">
          <img :src="item.image" alt="">
        </div>
        <div class="right">
          <div class="title">
            <span>{{item.title}}</span>
          </div>
          <div class="message">
            <div class="tag">
              <span v-if="item.tag && JSON.parse(item.tag)[0]">{{JSON.parse(item.tag)[0]}}</span>
            </div>
            <span class="time">{{item.createtime | formatDate}}</span>
          </div>
        </div>
      </li>
    </ul>
<!--    学习记录-->
    <van-empty v-if="tabIndex === 0 && checkListData.length < 1" class="custom-image" :image="learning"
    />
<!--    收藏-->
    <van-empty v-if="tabIndex === 1 && liveListData.length < 1" class="custom-image"  :image="collect" />
  </div>
</template>

<script>
import Collect from '../../assets/user/Collect.png'
import Learning from '../../assets/user/Learning.png'
import {formatDate} from "@/common/js/data";

export default {
  name: "UserContentList",
  props: {
    tabIndex: Number,
    liveListData: {
      type: Array,
      default: () => []
    },
    checkListData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      learning: Learning, // 学习记录
      collect: Collect, // 收藏
      listData: this.checkListData
    }
  },
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy.MM.dd')
    }
  },
  watch: {
    tabIndex(value) {
      if (value === 0) {
        this.listData = this.checkListData
      } else {
        this.listData = this.liveListData
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.listData = this.checkListData
    })
  },
  methods: {
    pushTo(item) {
      if (item.type === 1000) {
        this.$router.push({path: '/meetings/detail/' + item.activityid})
      } else {
        this.$router.push({path: '/case/detail/' + item.activityid})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .custom-image {
    .van-empty__image {
      width: 225px;
      height: 225px;
    }
  }
}
.box {
  min-height: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 26px 25px;
}
.list {
  li {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #ECECEC;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 24px 0;
    &:nth-last-child(1) {
      border: none;
    }
  }
  .left {
    width: 222px;
    height: 125px;
    margin-right: 40px;
    border-radius: 5px;
    overflow: hidden;
    img  {
      width: 100%;
      height: 100%;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    width: 437px;
    .title {
      margin-top: 12px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 30px;
      color: #333333;
    }
    .message {
      text-align: left;
      margin-top: 22px;
      display: flex;
      align-items: center;
      .tag {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        color: #ffffff;
        font-size: 20px;
        margin-right: 30px;
        span {
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          padding: 4px 18px;
          border-radius: 6px;
          display: block;
          background: #0090C5;
        }
      }
      .time {
        font-size: 24px;
        color: #333333;
      }
    }
  }
}
</style>
